import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import CompetitionRow from '../../../../components/CompetitionRow';
import CompetitionLastRow from '../../../../components/CompetitionLastRow';
import MatchRow from '../../../../components/MatchRow';
import CyclingRow from '../../../../components/CyclingRow';
import { CompetitionWrapper, CompetitionSpace } from './styles';
import MatchRowFav from '../../../../components/MatchRowFav';
import RaceRow from '../../../../components/RaceRow';
import TennisMatchRow from '../../../../components/TennisMatchRow';
import ConfigManager from '../../../../common/configManager/configManager';
import BasketMatchRow from '../../../../components/BasketMatchRow';
import { isCompetitionRoundLink, subPhaseLabel as subPhaseLabelCore } from '../../../../common/rcs_gaz_mc_core_FE';
import { isRoundInterval } from '../../../../helpers';
import { OddsChecker } from '../../../../components/RcsGazMcWidgets';

const CompetitionTable = ({
  showRowScorer,
  competition,
  actions,
  dictionary,
  isMobile,
  date,
  sportId,
  isHighlight,
  isDeskFav,
  isRace,
}) => {
  const competitionRoundName = (currentDay) => {
    const competitionId = `${currentDay.get('competitionId')}`;
    const competitionRound = currentDay.get('competitionRound');
    let titleLabel = dictionary.competitionTable.roundName[competitionRound];
    if ((competitionId === '6' || competitionId === '5' || competitionId === '1125' || competitionId === '1277') && competitionRound === 'Round') {
      titleLabel = `Giornata ${currentDay.get('competitionDay')}`
    }
    if (competitionId === '335') {
      switch (currentDay.get('competitionRound')) {
        case 'Qualifier Round':
          titleLabel = '1° turno';
          break;
        case 'Quarter-Finals':
          titleLabel = '2° turno';
          break;
        case 'Play-Offs':
          titleLabel = 'Finale per il 5° posto';
          break;
        default:
          titleLabel = dictionary.competitionTable.roundName[competitionRound];
          break;
      }
    } else if (competitionId === '105' && competition.get('calendarKey') === 'playoffs') {
      titleLabel = `Playoff - ${titleLabel}`
    }
    return titleLabel;
  };

  const setPhaseLabel = (currentDay) => {
    let label = '';
    if (competition.get('competitionName') === 'Champions League Qualifying' || competition.get('competitionName') === 'UEFA Europa League Qualifying' || competition.get('competitionName') === 'UEFA Europa Conference League Qualifying') {
      label = 'Preliminari';
    } else if ((competition.get('competitionName') === 'Champions League' || competition.get('competitionName') === 'UEFA Europa League' || competition.get('competitionName') === 'UEFA Europa Conference League')
    && (currentDay.get('competitionRound').indexOf('Round') < 0 || currentDay.get('calendarKey') === 'groups') && currentDay.get('calendarKey') !== 'playoffs') {
      label = `${currentDay.get('competitionDay')}${dictionary.competitionTable.dayA}`;
    } else if ((isCompetitionRoundLink(sportId, competition.get('competitionId'))) && currentDay.get('competitionRound') === 'Round') {
      label = `${currentDay.get('competitionDay')}${dictionary.competitionTable.dayA}`;
    } else if ((isCompetitionRoundLink(sportId, competition.get('competitionId'))) && isRoundInterval(currentDay.get('competitionDay'))) {
      let value = currentDay.get('competitionDay');
      value = `${value.substring(0, 4)}-${value.substring(4, 6)}-01`;
      label = new Date(value).toLocaleDateString('it-IT', { year: 'numeric', month: 'short' });
    } else if (String(competition.get('competitionId')) === '21' && (competition.get('competitionRound') === 'Final' || competition.get('competitionRound') === 'Play-Offs')) {
      label = 'Spareggio';
    } else {
      label = `${competitionRoundName(currentDay)}`;
    }
    return label;
  };

  const parseCompetionName = () => {
    let label = '';
    if (competition.get('competitionName') && competition.get('competitionName').indexOf('Qualifiers') !== -1) {
      label += 'Qualificazioni ';
    }
    label += dictionary.competitionTable.competitionName[competition.get('competitionId')];
    return label;
  }

  const parseBasketRound = (currentMatch) => {
    let title = '';
    if (String(currentMatch.get('competitionId')) === '3') {
      return title;
    }
    if (currentMatch.get('week')) {
      title = `${currentMatch.get('week')}${dictionary.competitionTable.dayA}`;
    } else if (currentMatch.get('phase')) {
      title = `${currentMatch.get('phase')}`;
      title = subPhaseLabelCore(title, dictionary.calendar.phases, sportId, currentMatch.get('competitionId'), true);
    }
    return title;
  };

  const isGazzanetFilter = () => {
    if (process.env.REACT_APP_SITE === 'fcinter' || process.env.REACT_APP_SITE === 'calcionapoli1926' || process.env.REACT_APP_SITE === 'forzaroma') {
      const compId = String(competition.get('competitionId'));
      if (compId !== '21' && compId !== '105' && compId !== '259' && compId !== '5' && compId !== '6' && compId !== '24' && compId !== '22' && compId !== '8' && compId !== '23' ) {
        return true;
      }
    }
    return false;
  }

  const competitionRowForSport = (currentDay) => {
    switch (sportId) {
      case '1':
        switch (competition.get('competitionId')) {
          case '4':
            return (
              competition && competition.get('competitionMatches').size > 0 && competition.get('competitionRound') === 'Round' ?
                (<CompetitionRow
                  name={dictionary.competitionTable.competitionName[competition.get('competitionId')]}
                  round={`${competition.get('competitionDay')}${dictionary.competitionTable.dayA}`}
                  isMobile={isMobile}
                  isHighlight={isHighlight}
                  competitionLink={dictionary.competitionLink[competition.get('competitionId')]}
                  calendarLink={process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'corriere' ? dictionary.calendarLink[ConfigManager.getEnv()] : dictionary.gazzanetCalendarLink[ConfigManager.getEnv()]}
                />) :
                competition && competition.get('competitionMatches').size > 0 &&
                <CompetitionRow
                  name={dictionary.competitionTable.competitionName[competition.get('competitionId')]}
                  round={dictionary.competitionTable.roundName[competition.get('competitionRound')]}
                  isMobile={isMobile}
                  competitionId={competition.get('competitionId')}
                  isHighlight={isHighlight}
                  competitionLink={dictionary.competitionLink[competition.get('competitionId')]}
                  calendarLink={process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'corriere' ? dictionary.calendarLink[ConfigManager.getEnv()] : dictionary.gazzanetCalendarLink[ConfigManager.getEnv()]}
                />
            );
          default:
            const roundLabel = `${currentDay.get('competitionId')}` === '21' && `${currentDay.get('competitionDay')}` === '39' ? 'Spareggio' : `${currentDay.get('competitionDay')}${dictionary.competitionTable.dayA}`;
            return (
              competition && competition.get('competitionMatches').size > 0 && competition.get('competitionType') === 'CUP' ?
                (<CompetitionRow
                  name={parseCompetionName()}
                  round={setPhaseLabel(currentDay)}
                  isMobile={isMobile}
                  isHighlight={isHighlight}
                  disableLink={isGazzanetFilter() || Number(competition.get('competitionId')) === 173}
                  competitionId={competition.get('competitionId')}
                  competitionLink={dictionary.competitionLink[competition.get('competitionId')]}
                  calendarLink={process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'corriere' ? dictionary.calendarLink[ConfigManager.getEnv()] : dictionary.gazzanetCalendarLink[ConfigManager.getEnv()]}
                />) :
                competition && competition.get('competitionMatches').size > 0 &&
                <CompetitionRow
                  name={dictionary.competitionTable.competitionName[competition.get('competitionId')]}
                  round={`${roundLabel}`}
                  isMobile={isMobile}
                  competitionId={competition.get('competitionId')}
                  isHighlight={isHighlight}
                  competitionLink={dictionary.competitionLink[competition.get('competitionId')]}
                  calendarLink={process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'corriere' ? dictionary.calendarLink[ConfigManager.getEnv()] : dictionary.gazzanetCalendarLink[ConfigManager.getEnv()]}
                />
            );
        }
      case '6C':
      case '6M':
        return (
          <CompetitionRow
            name={dictionary.competitionTable.raceCompetitionName[competition.get('competitionId')]}
            round={`${competition.get('raceTrack')} (${competition.get('isoCountry')})`}
            isMobile={isMobile}
            competitionId={competition.get('competitionId')}
            isHighlight={isHighlight}
            competitionLink={dictionary.raceCompetitionLink[competition.get('competitionId')]}
            calendarLink={dictionary.raceCalendarLink[ConfigManager.getEnv()]}
            isRace
          />
        );
      case '8':
        let objN = JSON.parse(JSON.stringify(currentDay.get('competitionMatches')))
        return (
          <CompetitionRow
            isTennis
            name={competition.get('name')}
            round={`${competition.get('class') === 'ATP Cup' || competition.get('class') === 'Fed Cup' || competition.get('class') === 'Davis Cup' ? '' : dictionary.competitionTable.tennisCompetitionName[competition.get('competitionName')]}`}
            isMobile={isMobile}
            competitionId={competition.get('competitionId')}
            isHighlight={isHighlight}
            phase={`${competition.get('class') === 'ATP Cup' || competition.get('class') === 'Fed Cup' || competition.get('class') === 'Davis Cup' ? '' : dictionary.competitionTable.roundNameTennis[objN[0].roundName]}`}
            competitionName={competition.get('competitionName')}
            tournamentType={competition.get('tournamentType') || competition.get('type')}
            tournamentName={competition.get('name')}
            competitionSex={competition.get('competitionSex')}
            disableLink={competition.get('class') === 'Davis Cup' || competition.get('class') === 'Fed Cup' || competition.get('class') === 'ATP Cup' || !competition.get('tournamentType') || !competition.get('name')}
          />
        );
      case '3':
        return (
          <CompetitionRow
            isBasket
            name={competition.get('competitionName')}
            isMobile={isMobile}
            competitionId={competition.get('competitionId')}
            isHighlight={isHighlight}
            competitionName={competition.get('competitionName')}
            round={parseBasketRound(currentDay)}
          />
        );
      default:
        return (
          <div />
        );
    }
  };
  const matchRowForSport = (currentGame, index) => {
    switch (sportId) {
      case '6C':
      case '6M':
        return (
          <RaceRow
            raceRow={currentGame}
            raceTrack={competition.get('raceTrack')}
            key={index}
            actions={actions}
            dictionary={dictionary}
            isMobile={isMobile}
            date={date}
            sportId={sportId}
            isHighlight={isHighlight}
            isDeskFav={isDeskFav}
            competitionId={competition.get('competitionId')}
            laps={competition.get('laps')}
          />
        );
      case '8':
        return (
          <TennisMatchRow
            matchRow={currentGame}
            key={index}
            showRowScorer={showRowScorer}
            actions={actions}
            dictionary={dictionary}
            isMobile={isMobile}
            date={date}
            sportId={sportId}
          />
        );
      case '3':
        return (
          <BasketMatchRow
            matchRow={currentGame}
            key={index}
            actions={actions}
            dictionary={dictionary}
            isMobile={isMobile}
            date={date}
            sportId={sportId}
            competitionId={competition.get('competitionId')}
          />
        );
      case '18':
        return (
          <CyclingRow
            matchRow={currentGame}
            key={index}
            actions={actions}
            dictionary={dictionary}
            isMobile={isMobile}
            date={date}
            sportId={sportId}
            competition={competition}
          />
        );
      default:
        if (isMobile && showRowScorer) {
          return (
            <MatchRowFav
              matchRow={currentGame}
              key={index}
              showRowScorer={showRowScorer}
              actions={actions}
              dictionary={dictionary}
              isMobile={isMobile}
              date={date}
              sportId={sportId}
              competitionId={competition.get('competitionId')}
              isFav
            />
          );
        }
        return (
          <MatchRow
            matchRow={currentGame}
            key={index}
            showRowScorer={showRowScorer}
            actions={actions}
            dictionary={dictionary}
            isMobile={isMobile}
            date={date}
            sportId={sportId}
            isHighlight={isHighlight}
            isDeskFav={isDeskFav}
            competitionId={competition.get('competitionId')}
          />
        );
    }
  };

  const showOddsChecker = () => {
    if (!isHighlight) {
      return false;
    } else if (sportId === '1' && process.env.REACT_APP_SITE === 'gazzetta') {
      const allowedCompetitions = [21, 5];

      if (allowedCompetitions.includes(Number(competition.get('competitionId')))) {
        return true;
      }
    }

    return false;
  };

  const sportBlock = () => {
    if (competition.get('competitionDays') && competition.get('competitionDays').size > 0 && sportId === '1') {
      return (
        competition.get('competitionDays').map((currentDay, currentDayInx) => (
          <React.Fragment key={currentDayInx}>
            {competitionRowForSport(currentDay)}
            {
              competition && competition.get('competitionMatches') &&
              competition.get('competitionMatches').filter(match => match.get('competitionDay') === currentDay.get('competitionDay')).map((currentGame, index) => (
                <LazyLoad height={80} offset={20} key={index}>
                  {matchRowForSport(currentGame, index)}
                </LazyLoad>
              ))
            }
          </React.Fragment>
        ))
      );
    } else {
      return (
        <React.Fragment>
          {competitionRowForSport(competition)}
          {
            competition.get('competitionMatches').map((currentGame, index) => (
              <LazyLoad height={80} offset={20} key={index}>
                {matchRowForSport(currentGame, index)}
              </LazyLoad>
            ))
          }
          {showOddsChecker() &&
            <OddsChecker 
              isV2 
              type='oc-odds-comparison' 
              competitionId={competition.get('competitionId')}
              position={isMobile ? 'mobile-a' : 'mid-article'}
              sportId={sportId}
              url={'https://www.gazzetta.it/risultati-live/'}
            />
          }
        </React.Fragment>
      );
    }
  };

  return (
    <CompetitionWrapper className={`last-bg-row ${competition && competition.get('competitionName').toLowerCase().replace(/ /g, '-')}`} isHighlight={isHighlight}>
      {competition && competition.get('competitionMatches') && competition.get('competitionMatches').size > 0 &&
        sportBlock()
      }

      {!isGazzanetFilter() && competition && competition.get('competitionMatches').size > 0 && !isHighlight && sportId !== '8' &&
        Number(competition.get('competitionId')) !== 174 && Number(competition.get('competitionId')) !== 173 &&
        <CompetitionLastRow sportId={sportId} competitionId={competition.get('competitionId')} dictionary={dictionary} isRace={isRace} isBasket={sportId === '3'} />
      }

      {(competition.get('competitionId') === '88' || competition.get('competitionId') === '34') && !isHighlight &&
        <CompetitionSpace />
      }

      {competition && competition.get('competitionMatches').size > 0 && sportId === '8' && competition.get('class') !== 'Davis Cup' && competition.get('class') !== 'ATP Cup' && competition.get('class')!== 'Fed Cup' &&
        <CompetitionLastRow
          competitionId={competition.get('competitionId')}
          competitionName={competition.get('competitionName')}
          tournamentType={competition.get('tournamentType') || competition.get('type')}
          competitionSex={competition.get('competitionSex')}
          tournamentName={competition.get('name')}
          dictionary={dictionary}
          isRace={isRace}
          isTennis={sportId === '8'}
          sportId={sportId}
          disableLink={competition.get('class') === 'Davis Cup' || competition.get('class') === 'Fed Cup' || competition.get('class') === 'ATP Cup' || !competition.get('tournamentType') || !competition.get('name')}
        />
      }
    </CompetitionWrapper>
  );
};

CompetitionTable.propTypes = {
  competition: PropTypes.shape({
    competitionName: PropTypes.string,
    competitionDay: PropTypes.any,
    competitionMatches: PropTypes.any,
    day: PropTypes.any,
    isHighlight: PropTypes.bool,
  }),
  dictionary: PropTypes.any,
  actions: PropTypes.any,
  isMobile: PropTypes.bool,
  showRowScorer: PropTypes.any,
  date: PropTypes.any,
  sportId: PropTypes.any,
  isDeskFav: PropTypes.bool,
  isRace: PropTypes.bool,
  isHighlight: PropTypes.bool,
};

export default CompetitionTable;

